export default __webpack_public_path__ + "static/media/µ¡úõ¥º-rgb µïÀÞ┤Ø.58d9c5a0.jpg";